<template>
  <div style="text-align: center" class="workxj">
    <div class='toolTitle'>作业票复制
      <van-icon name="cross" @click="close" />
    </div>
    <form action="/" style="padding-top:1.25rem;">
      <van-search show-action v-model="searchData.zynr" placeholder="请输入作业内容" shape="round" clearable @search="search">
        <template #action>
          <div @click="search">搜索</div>
        </template>
      </van-search>
    </form>

    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadTableData" style='height:calc(100% - 1.25rem - 144px);overflow:auto;'>
      <van-checkbox-group v-model="selectedId">
        <van-cell-group class="van-group-css">
          <van-cell v-for="(item,index) in tableData" :key="item.ID">
            <van-row class="vanRow">
              <van-col span="6" class="title-row">
                <label>作业证编号:</label>
              </van-col>
              <van-col span="18" class="title-row">
								<span style="padding-left: 3px;">
									{{item.ZYZBH}}
								</span>
              </van-col>
            </van-row>
            <van-row class="vanRow">
              <van-col span="6" class="title-row">
                <label>作业内容:</label>
              </van-col>
              <van-col span="18" class="title-row">
								<span style="padding-left: 3px;">
									{{item.ZYNR}}
								</span>
              </van-col>
            </van-row>
            <van-row class="vanRow">
              <van-col span="6" class="title-row">
                <label>开始时间:</label>
              </van-col>
              <van-col span="18" class="title-row">
								<span style="padding-left: 3px;">
									{{item.ZYKSSJ}}
								</span>
              </van-col>
            </van-row>
            <van-row class="vanRow">
              <van-col span="6" class="title-row">
                <label>结束时间:</label>
              </van-col>
              <van-col span="18" class="title-row">
								<span style="padding-left: 3px;">
									{{item.ZYJSSJ}}
								</span>
              </van-col>
            </van-row>
            <van-row class="vanRow">
              <van-col span="6" class="title-row">
                <label>作业类别:</label>
              </van-col>
              <van-col span="18" class="title-row">
								<span style="padding-left: 3px;">
									{{item.ZYLB}}
								</span>
              </van-col>
            </van-row>
            <van-row class="vanRow">
              <van-col span="6" class="title-row">
                <label>状态:</label>
              </van-col>
              <van-col span="18" class="title-row">
								<span style="padding-left: 3px;">
									{{item.ZYZT}}
								</span>
              </van-col>
            </van-row>
            <template #right-icon>
              <van-checkbox :name="item" ref="zlgjcheckboxes" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </van-list>
    <div class="bottomBar" style="position:fixed;width:100%;bottom:0">
      <van-button class="buttonItem" style="width: 100%;border: 1px solid #F0F0F0;" type="primary" @click="copyButton">确定</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "copyWorkList",
  data(){
    return {
      workType: this.$route.params.workType,
      xgfbz : this.$route.params.xgfbz,
      selectedId:[],
      loading: false,
      finished: false,
      page:1,
      pageSize:10,
      total:0,
      searchData:{
        zynr:''
      },
      tableData:[]
    }
  },
  methods: {
    copyButton(){
      if (this.selectedId.length === 0){
        this.$message.error('选择要复制的作业！');
        return;
      }
      if (this.selectedId.length > 1){
        this.$message.error('选择一条复制的作业！');
        return;
      }
      let obj = {
        id:this.selectedId[0].ID
      }
      this.$axios.post('/dform/index/copyWork',obj)
          .then((res) => {
            if (res.data.code == 1) {
              this.$message.success('操作成功！');
            }else{
              this.$message.error('操作失败！');
            }
          })
    },
    search(){
      this.page = 1
      this.pageSize = 10
      this.tableData = []
      this.loadTableData()
    },
    loadTableData(){
      let that = this
      let qyguid = sessionStorage.getItem('qyguid')
      let GCMZ = sessionStorage.getItem('GCMZ')
      let obj = {
        GCMZ: GCMZ,
        GCID: qyguid,
        ZYNR: that.searchData.zynr,
        ZYLB: that.workType,
        BDZL:'集团危险作业标准单',
        limit:that.pageSize,
        page:that.page,
      }
      if (this.xgfbz === 1){
        obj.XGFBS = sessionStorage.getItem('correlation')
      }
      this.$axios.post('/dform/index/selectList',obj)
          .then((res) => {
            if (res.data.code == 1) {
              that.total = res.data.data.total
              res.data.data.rows.forEach((value) => {
                that.tableData.push(value);
              });
              // 加载状态结束
              that.loading = false
              // 数据全部加载完成
              if (that.tableData.length >= that.total) {
                that.finished = true
              }
              that.page = that.page + 1
            }
          })
    },
    close() {
      this.$router.go(-1);
    },
  },
  created(){
  }

}
</script>

<style scoped lang="less">
.toolTitle{
  position: absolute;
  width: 100%;
  height: 1.25rem;
  line-height: 1.25rem;
  color: #454545;
  background: #f2f2f2;
  text-align: center;
  z-index: 1;
  font-size: .45rem;
  i{
    position: absolute;
    font-size: 20px;
    right: 15px;
    top: 12px;
    color: #787878;
  }
}

.workxj {
  overflow: auto !important;

  .van-list {
    padding: 10px;

    .van-group-css {
      margin-bottom: 6px;
      padding-bottom: 14px;
      border-radius: 4px;

      .vanRow {
        padding: 4px 15px;
      }
    }

    .van-cell {
      padding: 10px;
      border-bottom: 1px solid #ececec;
      margin-bottom: 4px;
      background: none;

      .van-cell__title {
        font-weight: bold;
      }
    }
  }


  .van-row {
    .van-button {
      margin-top: 2vw;
      border: 1px solid #1989fa;
      line-height: 1rem;
      height: 1rem;
      border-radius: 4px;
      display: block;
      width: 100%;
      text-align: center;

      .van-button__icon {
        font-size: 1.2em;
        color: #1989fa;
        line-height: 1rem;
      }

      span {
        // color: #1989fa !important;
        margin-left: 4px;
      }
    }

    .van-button--normal {
      padding: 0;
      font-size: 14px;
    }
  }
}
</style>
